export const ABONEMENT_WIZARD_OPEN_EVENT = 'palma:open-abonement-wizard';

export function openAbonementPurchaseWizard(purchaseUrl, options = {}) {
  if (typeof window === 'undefined') {
    return false;
  }

  window.dispatchEvent(new CustomEvent(ABONEMENT_WIZARD_OPEN_EVENT, {
    detail: {
      requiredTariffType: options.requiredTariffType || '',
    },
  }));

  if (!document.getElementById('abonement-wizard-root')) {
    if (purchaseUrl) {
      window.location.href = purchaseUrl;
    }
    return false;
  }

  try {
    const url = new URL(window.location.href);
    url.searchParams.set('buy_abonement', '1');
    window.history.replaceState({}, '', url.pathname + url.search);
  } catch (error) {
    // ignore URL update errors in older browsers
  }

  return true;
}

export function handleJoinRequiresAbonement(joinRes) {
  if (!joinRes || !joinRes.data || !joinRes.data.requires_abonement) {
    return false;
  }

  openAbonementPurchaseWizard(joinRes.data.purchase_url);
  return true;
}
